import { IHomepageMainNavItems } from "../../../../../types/working-model";

interface IPeopleProps {
	navItem: IHomepageMainNavItems | undefined;
}

const People: React.FC<IPeopleProps> = ({ navItem }) => {

	if (!navItem?.is_on) return null;
	return (
		<>People</>
	);
};

export default People;
